import apiClient from "@/lib/api/api-client";
import { env } from "@/config/env";

export interface ResetPasswordRequest {
  token: string;
  password: string;
}

export interface ResetPasswordResponse {
  message: string;
}

export async function confirmPasswordReset(payload: ResetPasswordRequest) {
  const { data } = await apiClient.post<ResetPasswordResponse>(
    env.authResetPasswordPath,
    payload,
  );
  return data;
}
